import styled from 'styled-components'

export const IntakeStepCol = styled.div`
  flex: 1 1 auto;
`



// WEBPACK FOOTER //
// ./src/atoms/IntakeStepCol.tsx